export const faqData = [
  {
    id: 1,
    question: 'O programa é 100% online?',
    answer: 'Sim! Todos os encontros acontecem ao vivo via Zoom, permitindo que você participe de qualquer lugar do Brasil ou do mundo. Você só precisa de uma conexão com internet.'
  },
  {
    id: 2,
    question: 'As aulas ficam gravadas?',
    answer: 'Sim! Todas as aulas ao vivo são gravadas e ficam disponíveis na plataforma para você assistir quando quiser. Você tem acesso ilimitado às gravações durante todo o programa.'
  },
  {
    id: 3,
    question: 'Posso entrar no programa depois que ele começar?',
    answer: 'Sim! Você pode entrar a qualquer momento. Terá acesso às gravações dos módulos anteriores e poderá acompanhar os próximos encontros ao vivo. A flexibilidade é uma das nossas prioridades.'
  },
  {
    id: 4,
    question: 'O programa oferece certificado?',
    answer: 'Sim! Ao concluir o programa, você recebe um certificado de conclusão do Eu Lidero, validando seu desenvolvimento em liderança feminina.'
  },
  {
    id: 5,
    question: 'Existe suporte durante o programa?',
    answer: 'Sim! Você terá acesso a um grupo exclusivo no WhatsApp para tirar dúvidas, trocar experiências com outras participantes e receber suporte da equipe durante toda a jornada.'
  },
  {
    id: 6,
    question: 'Posso comprar módulos avulsos?',
    answer: 'Sim! Se você preferir focar em temas específicos, oferecemos a opção de compra de módulos avulsos. Entre em contato para saber mais sobre valores e disponibilidade.'
  },
  {
    id: 7,
    question: 'Qual a duração de cada encontro?',
    answer: 'Cada encontro tem 4 horas de duração, com intervalos estratégicos. São 10 encontros mensais, totalizando 40 horas de conteúdo ao vivo, além das ferramentas práticas.'
  },
  {
    id: 8,
    question: 'E se eu perder um encontro ao vivo?',
    answer: 'Sem problemas! Você pode assistir à gravação quando quiser e também tem a opção de fazer reposição em turmas futuras, garantindo que você não perca nenhum conteúdo importante.'
  }
];
